const state = {
  itensSla: {
    fornecedor: Object,
    contrato: Array,
    itensSla: Array,
    evidencias: Array
  },
  controleExibicaoImpressao: false
}

const mutations = {
  setItensSla (state, obj) {
    state.itensSla = obj
  },
  setControleExibicaoImpressao (state, valor) {
    state.controleExibicaoImpressao = valor
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/itensSla.js